import { BlockStack, Box, Card, Link, Text } from '@shopify/polaris';
import CustomBadge from '#client/components/common/CustomBadge/CustomBadge';
import { useLocation } from 'react-router';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';

export default function PurchaseOrderReceivingHeader({ asnId, navigate, poId, rdId, displayStatus, parentData, name, totalItems = 0 }) {
    const location = useLocation();
    const passedState = location?.state;

    // Only show rdId if it's not "new" (indicating it came from the server)
    const shouldShowRdId = rdId && rdId !== 'new';
    return (
        <Card>
            <BlockStack>
                <Text variant="headingLg">{shouldShowRdId ? name : ''}</Text>
                <Box style={{ marginTop: '0.75rem' }}>
                    <Text as="p" variant="bodyMd">
                        <b>{PURCHASE_ORDER_STRINGS.STATUS}:</b> {displayStatus && displayStatus !== 'Loading...' && <CustomBadge status={displayStatus} />}
                    </Text>
                </Box>
                <Box>
                    <Box>
                        <Text>
                            <b>{PURCHASE_ORDER_STRINGS.PURCHASE_ORDER}: </b>
                            <Link
                                style={{ color: '#005BD3' }}
                                onClick={() =>
                                    navigate(`/purchase-orders/${poId}`, {
                                        state: {
                                            poId: poId,
                                            asnId: asnId,
                                            rdId: rdId,
                                            netsuiteId: passedState?.netsuiteId,
                                            parentData: parentData,
                                        },
                                    })
                                }
                            >
                                {parentData?.netSuiteHumanPoNumber || passedState?.netSuiteHumanPoNumber || passedState?.poId || poId}
                            </Link>
                        </Text>
                        {passedState?.asnNetsuiteId && (
                            <Text>
                                <b>{PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_RECEIVING_DOCUMENT.PURCHASE_ORDER_RECEIVING_HEADER.ASN}: </b>
                                <Link
                                    style={{ color: '#005BD3' }}
                                    onClick={() =>
                                        navigate(`/purchase-orders/${poId}/advanced-shipping-notice/${asnId}`, {
                                            state: {
                                                poId: poId,
                                                asnId: asnId,
                                                rdId: rdId,
                                                netsuiteId: passedState?.netsuiteId,
                                                parentData: parentData,
                                            },
                                        })
                                    }
                                >
                                    {passedState?.asnNetsuiteId}
                                </Link>
                            </Text>
                        )}
                        <Text as="p" alignment="end">
                            <b>{PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_RECEIVING_DOCUMENT.PURCHASE_ORDER_RECEIVING_HEADER.TOTAL_ITEMS}: </b>
                            {totalItems}
                        </Text>
                    </Box>
                </Box>
            </BlockStack>
        </Card>
    );
}
